<script>
export default {
    props: ['data'],
    name: "onlineBanner",
    data() {
        return {
            swiperOptions1: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
            swiperOptions2: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
            list: [],
            time: null,
        };
    },
    computed: {
        timeToText() { 
            return function (num) { 
                const day = parseInt(num / 1000 / 60 / 60 / 24);
                const hours = parseInt(num / 1000 / 60 / 60 % 24);
                const minutes = parseInt(num / 1000 / 60 % 60);
                const seconds = parseInt(num / 1000 % 60);
                return `${day}天${hours}小时${minutes}分${seconds}秒`;
            }
        },
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        data(value) { 
            this.list = value.map(v => {
                const countdown = this.getCountdown(v.start_time);
                return {
                    ...v,
                    countdown
                }
            })
            if( this.time ) clearInterval(this.time);
            this.updateCountdown();
        }
    },
    methods: {
        // 倒计时
        updateCountdown() { 
            this.time = setInterval(() => {
                this.list.forEach((v, i) => {
                    if (v.countdown > 0) { 
                        this.$set(this.list[i], 'countdown', v.countdown - 1000);
                    }
                })
            }, 1000)
        },
        // 获取离开展的毫秒数
        getCountdown(time) { 
            return new Date(time).getTime() - new Date().getTime();
        }
    },
};
</script>

<template>
    <swiper class="online_banner" :options="data.length > 1 ? swiperOptions1 : swiperOptions2">
        <swiper-slide v-for="(item, index) in list" :key="index">
            <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
            <div class="content layout_main flex justify_end align_center">
                <div class="text text_shadow">
                    <p class="name">{{ item.tag }}</p>
                    <p class="title">{{ item.name }}</p>
                    <p class="time">{{ item.start_time }} - {{ item.end_time }}</p>
                    <p class="desc" v-html="$textToHtml(item.desc)"></p>
                    <p class="remaining" v-if="item.countdown && item.countdown > 0">开始倒计时 {{ timeToText(item.countdown) }}</p>
                </div>
            </div>
        </swiper-slide>
        <template v-if="data.length > 1">
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </template>
    </swiper>
</template>

<style scoped lang="scss">
.online_banner{
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 9.2rem;
    }
    .bg{
        position: absolute;
    }
    .content{
        height: 100%;
        @media only screen and (max-width: 750px) {
            justify-content: center;
            align-items: flex-end;
            padding-bottom: 1rem;
        }
    }
    .text{
        position: relative;
        width: 4rem;
        color: #fff;
        .name{
            font-size: .4rem;
        }
        .title{
            font-size: .3rem;
        }
        .time{
            font-size: .22rem;
            margin-bottom: .1rem;
        }
        .desc{
            font-size: .18rem;
            // color: #666;
            padding-bottom: .05rem;
        }
        .remaining{
            border-top: 1px solid #fff;
            font-size: .25rem;
        }
        @media only screen and (max-width: 750px) {
            width: 5.2rem;
            text-align: center;
            .desc{
                font-size: .28rem;
            }
            .remaining{
                font-size: .28rem;
            }
        }
    }
    --swiper-navigation-color: #999;/* 单独设置按钮颜色 */
    --swiper-navigation-size: .26rem;/* 设置按钮大小 */
    .swiper-button-prev,
    .swiper-button-next{
        top: 50%;
        margin-top: 0;
        transform: translate(0, -50%);
        padding: .3rem;
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: 2.8rem;
    }
    .swiper-button-next{
        right: 2.8rem;
    }
}
</style>